export const PHONE = "(507) 829-2069";
export const PHONE_LINK = "tel:" + PHONE;

export const EMAIL = "zach@zachrmccoy.com";
export const EMAIL_LINK = "mailto:" + EMAIL;